export const TOUR_MODEL_STATUS = 'tour/TOUR_MODEL_STATUS';

export const toggleModelTour = (isDisplay) => {
  return function (dispatch) {
    dispatch({ type: TOUR_MODEL_STATUS, data: { modelStatus: isDisplay } })
  };
};